import type { JourneyPhase } from './journey-state';
import type { TrackingMode } from '../types';

export function shouldStartNavigation(
  previousTracking: TrackingMode,
  nextTracking: TrackingMode,
  phase: JourneyPhase,
  hasFocusedRoute: boolean
): boolean {
  return previousTracking === 'locate'
    && nextTracking === 'follow'
    && phase === 'route_ready'
    && hasFocusedRoute;
}
